import * as API from '@/generated/api/api';
import env from '@env';

namespace SBAPI {
    export type Artist = API.Artist;
    export type ArtistTypeEnum = API.ArtistTypeEnum;
    export type ArtistPageTypeEnum = API.ArtistPageTypeEnum;
    export type Plan = API.Plan;
    export type User = API.User;
    export type UserPlan = API.UserPlan;
    export type Order = API.Order;
    export type PlanOrderHistory = API.PlanOrderHistory;
    export type PlanOrderGoods = API.PlanOrderGoods;
    export type FormData = API.FormData;
    export type Redirect = API.Redirect;
    export type Banner = API.Banner;
    export type News = API.News;

    export function user(): API.User {
        return {
            email: "",
            name: "",
            zip: "",
            address: "",
            address2: "",
            birthday: "",
            gender: <any>"UNKNOWN",
            tel: "",
            code: "",
        };
    }

    export function artist(): API.Artist {
        return {
            "coverImage": "string",
            "description": "string",
            "icon": "string",
            "id": 0,
            "name": "string",
            "subName": "string",
            "slug": "string",
            "type": API.ArtistTypeEnum.OTHER,
            "attribute": {},
            "copyright": "",
            "backgroundColor": "",
            "sort": 0,
        };
    }

    export function plan(): API.Plan {
        return {
            "artist": artist(),
            "description": "string",
            "attention": "string",
            "period": 0,
            "id": 0,
            "name": "string",
            "price": 0,
            "preTaxPrice": 0,
            "sort": 0,
        };
    }

    export function order(): API.Order {
        return {
            "id": 0,
            "plan": plan(),
            "name": "string",
            "price": 0,
            "preTaxPrice": 0,
            "endDate": new Date,
            "shipDate": "string",
        };
    }

    export function userPlan(): API.UserPlan {
        return {
            count: 1,
            plan: SBAPI.plan(),
            user: SBAPI.user(),
        };
    }

    export function planOrderHistory(): API.PlanOrderHistory {
        return {
            "user": SBAPI.user(),
            "order": SBAPI.order(),
            "paymentMethod": API.PlanOrderHistoryPaymentMethodEnum.CARD,
            "paymentStatus": API.PlanOrderHistoryPaymentStatusEnum.ERROR,
            "count": -100,
            "price": 0,
            "preTaxPrice": 0,
            "shipNumber": "",
            "shipSrcName": "",
            "shipZip": "",
            "shipAddress": "",
            "shipAddress2": "",
            "shipDestName": "",
            "shipTel": "",
            "paidAt": "2019-11-11 19:10:29",
        }
    }

    export function news(): API.News {
        return {
            title: "",
            message: "",
            openFlag: false,
        };
    }

    export const ArtistController = API.ArtistControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const LoginController = API.LoginControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const MailController = API.MailControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const PlanController = API.PlanControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const UserController = API.UserControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const UserPlanController = API.UserPlanControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const CreditController = API.CreditControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const PlanOrderHistoryController = API.PlanOrderHistoryControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const PlanOrderGoodsController = API.PlanOrderGoodsControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const RedirectController = API.RedirectControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const BannerController = API.BannerControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);
    export const NewsController = API.NewsControllerApiFactory({ baseOptions: env.API_CONFIG }, env.API_ORIGIN);

}
export default SBAPI;
